import NotInsuredLabel from './NotInsuredLabel'
export default NotInsuredLabel
